import * as api from './api';
import * as factories from './factories';
import * as schema from './validation';

export const PhaseModel = {
  ...api,
  ...factories,
  ...schema,
};
